import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export class User {
  constructor(public name: string, public selected?: boolean) {
    if (selected === undefined) selected = false;
  }
}

@Component({
  selector: 'app-filterSearch',
  templateUrl: './filterSearch.component.html',
  styleUrls: ['./filterSearch.component.scss']
})
export class FilterSearchComponent implements OnInit, OnChanges {
  @Input() data: { placeholder: string; cityList: any[] };
  @Output() messageEvent = new EventEmitter<any>();

  placeholder: string;
  userControl = new FormControl();
  users: User[] = [];
  selectedUsers: User[] = [];
  filteredUsers: Observable<User[]>;
  lastFilter: string = '';

  constructor() {}

  ngOnInit() {
    this.filteredUsers = this.userControl.valueChanges.pipe(
      startWith<string | User[]>(''),
      map(value => (typeof value === 'string' ? value : this.lastFilter)),
      map(filter => this.filter(filter))
    );
  }

  ngOnChanges() {
    if (this.data.cityList.length) {
      this.users = this.data.cityList.map(city => new User(city));
    }
    this.placeholder = this.data.placeholder || 'Select users';
  }

  filter(filter: string): User[] {
    this.lastFilter = filter;
    if (filter) {
      return this.users.filter(option =>
        option.name.toLowerCase().includes(filter.toLowerCase())
      );
    } else {
      return this.users.slice();
    }
  }

  displayFn(value: User[] | string): string | undefined {
    if (Array.isArray(value)) {
      return value.map(user => user.name).join(', ');
    }
    return value;
  }

  optionClicked(event: Event, user: User): void {
    event.stopPropagation();
    this.toggleSelection(user);
  }

  toggleSelection(user: User): void {
    user.selected = !user.selected;
    if (user.selected) {
      this.selectedUsers.push(user);
    } else {
      const index = this.selectedUsers.findIndex(u => u.name === user.name);
      if (index > -1) {
        this.selectedUsers.splice(index, 1);
      }
    }
    this.userControl.setValue(this.selectedUsers);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'a') {
      event.preventDefault();
      this.selectAllOptions();
    }
  }

  selectAllOptions(): void {
    this.users.forEach(user => {
      if (!user.selected) {
        user.selected = true;
        this.selectedUsers.push(user);
      }
    });
    this.userControl.setValue(this.selectedUsers);
  }

  getSelected(): void {
    this.messageEvent.emit(this.userControl.value);
  }

}
